
export default {
  name: 'templatePrice',

  data () { return {} },
  methods: {
    openTemplatePrice () {
      this.$refs['add-user-modal'].show()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/pricetablemanagement/components/templatePrice/templatePrice.js